import { Controller } from "@hotwired/stimulus"

// A line that only sometimes needs explaining: an activity's anatomy fits on the
// row until it doesn't, and a tooltip on a line you can already read in full is
// noise. So the tip is in the markup and hidden, and this turns it on for the
// rows where the text is actually cut off.
export default class extends Controller {
  static targets = ["line", "tip"]

  connect() {
    this.check()
    this.observer = new ResizeObserver(() => this.check())
    this.observer.observe(this.lineTarget)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  check() {
    this.tipTarget.hidden = this.lineTarget.scrollWidth <= this.lineTarget.clientWidth
  }
}
